const toOptions = (values: string[]) => values.map(value => ({ label: value, id: value }));

// Paint codes from AirEng's Paint Group Code list, ENA first as the most used
export const paintCodeOptions = toOptions([
    'ENA : Phosphate Wash, 2 coats Standard enamel (Dulux Luxol 4QD or similar) over GOZP TDFT 100µm',
    'ABR : Blast Class 2.5, 2 coats Abrasion resistant ceramic filled epoxy CERAMKOTE TDFT 175-250µm',
    'BST : Blast Class 2.5, Blast Only',
    'GOZ : Phosphate Wash, 2 coats GOZ Primer TDFT 50µm',
    'HAL : Blast Class 2.5, 2 coats High Temperature AL Coating TDFT 200µm',
    'HBE : Blast Class 2.5, 2 coats 125µm Interplus 1180 TDFT 250µm',
    'HBU : Blast Class 2.5, 50-75µm Intercure (Zn), 125-175µm Interplus, 50µm Interthane (URE) TDFT 225-300µm',
    'HTA : Blast Class 2.5, 2 coats 25µm Intertherm (AL) TDFT 50µm',
    'IOZ : Blast Class 2.5, 2 coats Interzinc 2280 TDFT 60-90µm',
    'NIL : No Paint',
    'PAP : Pickle & Passivate Weld Areas',
    'PAS : Blast and Passivate Weld Areas',
    'PCW : Phosphate Wash, 1 coat Powder Coating Satin Finish, Oven Cure TDFT 80-100µm',
    'SCE : Blast Class 2.5, 2 coats Interplus TDFT 125-150µm',
    'URE : Blast Class 2.5, 50-75µm Intercure (Zn), 50µm Interthane (URE) TDFT 100-125µm',
    'ZEP : Blast Class 2.5, 2 coats Interzinc 52 TDFT 50-75µm',
    'ZPH : Blast Class 2.5, 2 coats Intercure 200 TDFT 50-75µm',
    'OTH : As per client specification',
    '1-Pack : Standard Primer',
    '1-Pack : Standard Primer + Standard Enamel',
    '2-Pack : Epoxy Primer – 75µm DFT',
    '2-Pack : Epoxy Primer + Polyurethane Top Coat – 125µm DFT',
    'High Build : Epoxy Primer + Polyurethane Top Coat – 200-225µm DFT',
    'Hi-Temp : 2-Coats Silicone High Temp (Rated <435°C) – 40µm DFT',
]);

// AS2700 colours from the same list
export const colourOptions = toOptions([
    'R64 Deep Indian Red (Roxby Red)',
    'B21 Ultramarine',
    'T45 Cootamundra',
    'X15 Orange',
    'Y14 Golden Yellow',
    'N64 Dark Grey',
    'N35 Light Grey',
    'B43 Grey Blue',
    'B15 Mid Blue',
    'B12 Royal Blue',
    'Alphatec French Blue Gloss 98432725 (Powder Coat)',
    'N14 White',
    'R13 Signal Red',
    'B64 Charcoal',
    'G17 Mint Green',
    'G25 Olive',
]);

// Which finish section a part or Other Options row is listed under on the Finish Scope
export const finishOptions = toOptions(['None', 'Internal', 'External', 'Both']);
